import { useSelector } from "react-redux";

/**
 * Retorna a entidade ativa selecionada na store Redux.
 *
 * @description
 * Este hook realiza as seguintes operações:
 * 1. Lê `data` e `current` da store `entidade`
 * 2. Busca a entidade cujo `entidade_id` corresponde a `default_entidade_id`
 * 3. Retorna a entidade encontrada ou `null`
 *
 * @returns {Object | null} Entidade ativa ou `null` quando não houver correspondência
 */
function useEntidade() {
  const { data: xData, current: xCurrent } = useSelector(
    (store) => store.entidade
  );

  // Busca a entidade ativa a partir do Redux store
  const xEntidade = Array.isArray(xData)
    ? xData.find(
        (xEntidade) => xEntidade.entidade_id === xCurrent?.default_entidade_id
      )
    : null;

  // Retorna a entidade atual (ou null se não encontrada)
  return xEntidade || null;
}

export default useEntidade;
